import { ElementType, TemplateElement } from '../model';

export const VisualElementText = (templateElement: TemplateElement) => {
    let visualElement = '';

    if (templateElement.type === ElementType.LineChart) {
        visualElement = 'REPORT_EDITOR.ADD_DATAPOINT_DIALOG.STEP.ADD_FILTER_LINECHART';
    } else if (templateElement.type === ElementType.ScatterPlot) {
        visualElement = 'REPORT_EDITOR.ADD_DATAPOINT_DIALOG.STEP.ADD_FILTER_SCATTERPLOT';
    }

    return visualElement;
};
